import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Role Management Service
 * !== 역할 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/mypage/myiqs`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/myiqs`,
    nodes: [],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0304001q: `${BASE.path}/ptli0304001q`, // List of MyIQSs        !== 나의 IQS  목록 ==!
    ptli0304002s: `${BASE.path}/ptli0304002s`, // Detail for MyIQSs     !== 나의 IQS 상세 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // View a IQS List !== IQS 목록 조회 ==!
    getIQSList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },
    // View Child List By ComnCode  !== 공통코드 자식 List 조회 ==!
    selectChildListByComnCd: (data: any) => {
        return api.post(`${BASE.api}/code`, {
            ...data,
        });
    },

    // save IQS !== IQS 저장 ==!
    saveIQSInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // View a IQS Detail !== IQS 상세 조회 ==!
    getIQSInfo: (iqsUuid: any) => api.get(`${BASE.api}/${iqsUuid}`),

    // View a IQS Search Option !== IQS 조회 조건 조회 ==!
    getDocOptList: () => api.get(`${BASE.api}/optList`),

    // View a IQS Detail !== IQS 상세 조회 ==!
    getIQSInfoByBsopId: (data: any) =>
        api.get(`${BASE.api}/getIqsInfo`, {
            params: data,
        }),

    // Regist IQS Comment  !== IQS 댓글 등록 ==!
    registIqsComment: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // Modify IQS Target Display YN !== IQS 대상자 조회 여부 수정==!
    modifyIqstrgtDispYn: (data: any) => {
        return api.post(`${BASE.api}/modifyIQSList`, {
            ...data,
        });
    },
};

const iqsSbjctlTpCdListArr = [
    { label: "Text", value: "T" },
    { label: "ComnCode", value: "C" },
];

export const SF_IQS_SRCH: TFormSchema = {
    id: "form_iqsSrch",
    schema: {
        srchFrstRegstId: { type: "text", label: "L_FRST_REGST_ID" },
        loginUsrId: { type: "text", label: "" },
        frstRgsrDtmRnge: {
            type: "daterange",
            label: "L_SRCH_PRID",
            start: { name: "regstSrchStrtDt" },
            end: { name: "regstSrchEndDt" },
            rangeButton: 2,
            // controlSize: 10,
        },
        reffNo : { type: "text", label: "L_REFF_NO"},
        docCdVal : { type: "select", label: "L_DOC_NM"},
        trgtDispYn : { type: "select", label: "L_HIDE_YN", select: false,
            options: [
                    { label: "No", value: "Y" },
                    { label: "Yes", value: "N" },
                ],
        },
        actor : { type: "select", label: "L_ACTR", area: "comnCd", comnCd: "CLR0058", viewType : "value"},
        cmntRegstId : { type: "text", label: "L_CMNT_RGST_ID"},
    },
};

export const SF_IQS_CMNT: TFormSchema = {
    id: "form_iqsCmnt",
    schema: {
        iqsCmntCn: { type: "textarea", required: true },
        cdVldVal: { type: "select" },
    },
};

export const SG_IQS: TGridSchema = {
    id: "grid_iqs",
    options: { edit: false, index: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_REFF_NO", binding: "reffNo", width: "20%" }] },
        { cells: [{ header: "L_DOC_NM", binding: "docCdValNm", width: "*" }] },
        { cells: [{ header: "L_READ_YN", binding: "rdngYn", width: "10%" }] },
        { cells: [{ header: "L_DTM", binding: "lastMdfyDtm", width: "15%" }] },
        { cells: [{ header: "L_FRST_REGST_ID", binding: "frstRegstId", width: "15%" }] },
    ],
    body: [
        { cells: [{ binding: "reffNo", type: "text", align: "left" }] },
        { cells: [{ binding: "docCdValNm", type: "text", align: "left" }] },
        { cells: [{ binding: "rdngYn", type: "text", align: "center" }] },
        { cells: [{ binding: "lastMdfyDtm", type: "datetime" }] },
        { cells: [{ binding: "frstRegstId", type: "text", align: "left" }] },
    ],
};
